import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#db4132',
            secondary: '#000000',
            accent: '#8c9eff',
            error: '#b71c1c',
          },
        },
      }
});
